import { ArrowBigRight } from "lucide-react";

const WhyFee = () => {
  return (
    <div className="p-3">
      <h1 className="text-3xl text-center text-sky-500 font-semibold mb-12">
        Why there is a fee for training?
      </h1>
      <div className="mx-auto max-w-4xl">
        <ul className="list-inside space-y-2 text-gray-700 text-lg">
          <li className="flex items-center gap-2">
            <ArrowBigRight size={20} />
            <p className="w-[80%] text-pretty">
              There is a training fee because it helps cover the cost levied by
              the Training Providing Partner for quality instruction, learning
              materials, infrastructure, and expert trainers. It also ensures
              structured, hands-on training, continuous support, and
              certification standards. The fee reflects the value of skills,
              practical exposure, and professional development provided during
              the program.
            </p>
          </li>
          <li className="flex items-center gap-2">
            <ArrowBigRight size={20} />
            <p className="w-[80%] text-pretty">
              The fee helps in compensating Experienced Professionals Partner
              conducting the training.
            </p>
          </li>
          <li className="flex items-center gap-2">
            <ArrowBigRight size={20} />
            <p className="w-[80%] text-pretty">
              The fee may provide access to updates, webinars platform cost, or
              additional learning resources during and after the training.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default WhyFee;
